export var Channel;
(function (Channel) {
    Channel["email"] = "email";
    Channel["browser"] = "browser";
})(Channel || (Channel = {}));
export var SubscriptionsError;
(function (SubscriptionsError) {
})(SubscriptionsError || (SubscriptionsError = {}));
var SubscriptionsRequest = /** @class */ (function () {
    function SubscriptionsRequest(query) {
        this.knownErrorCodes = Object.values(SubscriptionsError);
        this.path = "my/info-card-subscriptions?".concat(String(query.searchParams));
    }
    return SubscriptionsRequest;
}());
export { SubscriptionsRequest };
